// Tema claro/escuro do site. Guarda no localStorage e marca data-theme no <html>.
export type Theme = 'dark' | 'light';

const KEY = 'mania3d-theme';

// localStorage pode lançar exceção no Safari (modo privado / bloqueio de
// rastreamento). Envolve em try/catch pra NUNCA travar o carregamento do site.
function lsGet(k: string): string | null {
  try { return localStorage.getItem(k); } catch { return null; }
}
function lsSet(k: string, v: string): void {
  try { localStorage.setItem(k, v); } catch { /* ignora (Safari privado) */ }
}

export function getTheme(): Theme {
  // Padrao: claro (sol). Escuro so se o usuario tiver escolhido.
  return lsGet(KEY) === 'dark' ? 'dark' : 'light';
}

export function applyTheme(t: Theme): void {
  document.documentElement.dataset.theme = t;
  lsSet(KEY, t);
  window.dispatchEvent(new CustomEvent('themechange', { detail: t }));
}

/** Cor de fundo da cena 3D para cada tema. */
export function sceneBg(t: Theme): number {
  return t === 'light' ? 0xeef1f5 : 0x202428;
}
